import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => (<button
  style={props.styleVal}
  className={props.classVal || ''}
  onClick={() => props.onClickHandler()}>{props.name}
</button>);

Button.propTypes = {
  styleVal: PropTypes.object,
  classVal: PropTypes.string,
  name: PropTypes.string,
  onClickHandler: PropTypes.func.isRequired
};
export default Button;
